<section class="table-card" aria-labelledby="dashboard-table-heading">
  <div class="table-heading">
    <div>
      <h2 id="dashboard-table-heading">Detailed data</h2>
      <span>{{ total }} analyzed {{ dataType === "thread" ? "cases" : dataType + " records" }}</span>
    </div>
  </div>

  <div class="table-scroll">
    <table>
      <thead>
        <tr>
          @for (column of columns; track column) {
            <th
              [ngClass]="columnClass(column)"
              >
              @if (dataType === 'manufacturer' || dataType === 'part') {
                <span
                  [innerHTML]="rmHeaderLabel(column)"
                ></span>
              } @else {
                {{ columnLabel(column) }}
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of pagedRows; track row) {
          <tr>
            @for (column of columns; track column) {
              <td
                [ngClass]="columnClass(column)"
                >
                @if (dataType === 'manufacturer') {
                  @switch (columnType(column)) {
                    @case ('textCenter') {
                      <span class="text-center">
                        {{ cellValue(row, column) }}
                      </span>
                    }
                    @case ('navigateAction') {
                      <button
                        type="button"
                        class="cell-navigation"
                        (click)="navigateManufacturerCell(row, column)"
                        >
                        {{ cellValue(row, column) }}
                      </button>
                    }
                    @case ('badge') {
                      <span
                        class="badge status-badge text-center"
                        [hidden]="cellValue(row, column) === 'withoutData'"
                        [ngStyle]="dashboardStatusColor(row, column)"
                        >
                        {{ dashboardStatusText(row, column) }}
                      </span>
                    }
                    @case ('link') {
                      <a
                        [href]="cellValue(row, column)"
                        target="_blank"
                        >
                        @if (cellValue(row, column)) {
                          <i
                            class="fas fa-file icon-blue"
                          ></i>
                        }
                      </a>
                    }
                    @case ('decimalNumber') {
                      <span>
                        {{
                        app.field.formatNumberWithDecimals(
                        cellValue(row, column),
                        2
                        )
                        }}
                      </span>
                    }
                    @case ('date') {
                      <span>
                        {{
                        cellValue(row, column)
                        | date : "yyyy-MM-dd" : "UTC"
                        }}
                      </span>
                    }
                    @case ('optionText') {
                      <span>
                        {{ manufacturerOptionText(row, column) }}
                      </span>
                    }
                    @default {
                      <span>{{ cellValue(row, column) }}</span>
                    }
                  }
                } @else {
                  @if (dataType === 'part') {
                    @switch (columnType(column)) {
                      @case ('normal') {
                        <span>
                          {{ cellValue(row, column) }}
                        </span>
                      }
                      @case ('textCenter') {
                        <span class="text-center">
                          {{ cellValue(row, column) }}
                        </span>
                      }
                      @case ('navigateAction') {
                        <button
                          type="button"
                          class="cell-navigation"
                          (click)="navigateToPart(row, column)"
                          >
                          {{ cellValue(row, column) }}
                        </button>
                      }
                      @case ('badge') {
                        <span
                          class="badge status-badge text-center"
                          [hidden]="cellValue(row, column) === 'withoutData'"
                          [ngStyle]="dashboardStatusColor(row, column)"
                          >
                          {{ dashboardStatusText(row, column) }}
                        </span>
                      }
                      @case ('radio') {
                        @if (app.field.isTrue(cellValue(row, column))) {
                          <i
                            class="far fa-dot-circle"
                          ></i>
                        }
                        @if (app.field.isFalse(cellValue(row, column))) {
                          <i
                            class="fal fa-circle"
                          ></i>
                        }
                      }
                      @case ('decimalNumber') {
                        <span>
                          {{
                          app.field.formatNumberWithDecimals(
                          cellValue(row, column),
                          2
                          )
                          }}
                        </span>
                      }
                      @default {
                        <span>{{ cellValue(row, column) }}</span>
                      }
                    }
                  } @else {
                    @switch (columnType(column)) {
                      @case ('dueDate') {
                        <span>
                          @if (dueDateValue(row, column) > 0) {
                            <span
                              class="due-date"
                              [ngStyle]="dueDateStyle(row)"
                              >
                              {{
                              dueDateValue(row, column)
                              | date : "yyyy-MM-dd" : "UTC"
                              }}
                            </span>
                          }
                        </span>
                      }
                      @default {
                        @if (rowUrl(row); as url) {
                          <a
                            [routerLink]="url"
                            class="cell-link"
                            >
                            @if (
                              columnType(column) === 'optionText') {
                              @if (
                                isThreadStatusColumn(column)) {
                                <span
                                  class="badge status-badge"
                                  [ngStyle]="dashboardStatusColor(row, column)"
                                  >
                                  {{ threadOptionText(row, column) }}
                                </span>
                              } @else {
                                {{ threadOptionText(row, column) }}
                              }
                            } @else {
                              {{ displayValue(row, column) }}
                            }
                          </a>
                        } @else {
                          @if (
                            columnType(column) === 'optionText') {
                            @if (
                              isThreadStatusColumn(column)) {
                              <span
                                class="badge status-badge"
                                [ngStyle]="dashboardStatusColor(row, column)"
                                >
                                {{ threadOptionText(row, column) }}
                              </span>
                            } @else {
                              {{ threadOptionText(row, column) }}
                            }
                          } @else {
                            {{ displayValue(row, column) }}
                          }
                        }
                      }
                    }
                  }
                }
              </td>
            }
          </tr>
        }
        @if (rows.length === 0) {
          <tr>
            <td [attr.colspan]="columns.length || 1" class="empty-row">No analyzed records were returned.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (total > 0) {
    <div class="table-pagination">
      <span>Showing {{ pageStart }} to {{ pageEnd }} of {{ total }} entries</span>
      <nav class="pagination-controls" aria-label="Table pagination">
        <button type="button" (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1" aria-label="Previous page">
          <i class="far fa-angle-left"></i>
        </button>
        @for (page of visiblePages; track page) {
          <button type="button" (click)="setPage(page)" [class.active]="page === currentPage">
            {{ page }}
          </button>
        }
        <button type="button" (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages" aria-label="Next page">
          <i class="far fa-angle-right"></i>
        </button>
      </nav>
      <span>{{ pageSize }} / page</span>
    </div>
  }
</section>
